import { render, staticRenderFns } from "./shareLeadWithLeaderOrConsultor.vue?vue&type=template&id=4cd7697c"
import script from "./shareLeadWithLeaderOrConsultor.vue?vue&type=script&lang=js"
export * from "./shareLeadWithLeaderOrConsultor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports